import { getConceptCodes } from './fetchers';
import { ConceptCodesResponse } from './concept-codes.dto';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export function useGetConceptCodes(
  { jobId }: { jobId: string },
  options?: UseQueryOptions<ConceptCodesResponse>,
) {
  return useQuery({
    queryKey: ['concept-codes', jobId],
    queryFn: async () => getConceptCodes({ jobId }),
    ...options,
  });
}
